import React from "react";
import { ErrorCard } from "@weezevent/nacre";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import logoError from "../../images/error-404.svg?url";

const NotFoundPage = ({
	title = null,
	subTitle = null,
	backHomeUrl = null,
	refresh = true
}) => {
	const { t } = useTranslation();
	const history = useHistory();

	const errorTitle = React.useMemo(() => {
		if (title) {
			return t(title);
		}
		return t("access.common.error.labelNotFound");
	}, [title, t]);

	const errorSubTitle = React.useMemo(() => {
		if (subTitle) {
			return t(subTitle);
		}
		return t("access.common.error.errorCodeLabel", { code: 404 });
	}, [subTitle, t]);

	const onBackHome = React.useCallback(() => {
		history.push(backHomeUrl);
	}, [history, backHomeUrl]);

	const onRefresh = React.useCallback(() => {
		window.location.reload(false);
	}, []);

	return (
		<ErrorCard
			image={logoError}
			title={errorTitle}
			subTitle={errorSubTitle}
			onRefresh={!refresh ? null : onRefresh}
			onBackHome={backHomeUrl ? onBackHome : null}
			labelRefresh={t("access.common.cta.refresh")}
			labelBackHome={t("access.common.cta.backHome")}
		/>
	);
};

NotFoundPage.propTypes = {
	title: PropTypes.string,
	subTitle: PropTypes.string,
	backHomeUrl: PropTypes.string,
	refresh: PropTypes.bool
};

export default NotFoundPage;
